import {ref} from 'vue';

export default {
    install: (app, options) => {
        const roles = ref([]);

        const loadRoles = (urlParameters) => {
            const defaultUrlParameters = {
                category: null,
            };

            urlParameters = Object.assign(defaultUrlParameters, urlParameters)

            const urlSearchParams = new URLSearchParams(urlParameters);

            window.lazy_axios.get(`/roles/?all=true&${urlSearchParams.toString()}`)
                .then((response) => {
                    if (response.data.roles) {
                        roles.value = response.data.roles.data;
                    }
                });
        };

        app.provide('roles', roles);
        app.provide('loadRoles', loadRoles);
    },
}
